<div class="subtitle-container">
  <span class="date-text">{{ datetime }}</span>
</div>
<p-divider></p-divider>
<div [innerHTML]="htmlString"></div>
<p-divider></p-divider>
<div class="footer">
  <span>Signed by: {{ signature }}</span>
  <button pButton pRipple type="button" class="close-button" (click)="closeDialog()">Close</button>
</div>
